import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { FirstRunPushComponent } from "./first-run-push.component";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule],
  declarations: [FirstRunPushComponent],
  exports: [FirstRunPushComponent],
})
export class FirstRunPushComponentModule {}
